import { useMediaQuery, useTheme } from '@mui/material';

export default function useIsMobile(breakpoint: 'xs' | 'sm' | 'md' | 'lg' = 'sm') {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint));
}
